<template>
  <div class="bg-[#F5F6FA]">
    <div class="w-full min-h-screen flex gap-8">
      <!-- Left Navigation Section -->
      <OnboardingNav />

      <!-- Right Content Section -->
      <div class="flex-[7] flex flex-col items-center justify-between ">
        <router-view v-slot="{ Component }">
          <component :is="Component" />
        </router-view>
        <!-- Progress Indicators -->
        <div class="inset-x-0 mb-10 flex justify-center">
          <ul class="steps flex items-center">
            <li v-for="(step, index) in steps" :key="index"
                :class="[
                  'h-[6px] w-[3rem] rounded-full mr-[12px] transition-all duration-300',
                  isStepVisited(step.route) ? 'bg-[#00423D] cursor-pointer' : 'bg-[#EBE8E1]'
                ]"
                @click="navigateToStep(step.route)">
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import OnboardingNav from "@/components/OnboardingNav.vue";
import { useOnboardingStore } from "@/stores/onboarding";

const route = useRoute();
const router = useRouter();
const onboardingStore = useOnboardingStore();

// Steps Array - this matches exactly with OnboardingNav.vue
const steps = [
  { label: "Welcome", route: "/onboarding/welcome" },
  { label: "Tell us about Your Organization", route: "/onboarding/organization" },
  { label: "Tell us about you", route: "/onboarding/about-you" },
  // { label: "Fundraising & Sustainability Self-Assessment", route: "/onboarding/self-assessment" },
  { label: "Collaboration & Adding Team Members", route: "/onboarding/team" },
];

// Check if a step has been visited
const isStepVisited = (stepRoute) => {
  return onboardingStore.isRouteAccessible(stepRoute);
};

// Navigate to a step if it has been visited
const navigateToStep = (stepRoute) => {
  if (isStepVisited(stepRoute)) {
    router.push(stepRoute);
  }
};
</script>
